





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AudioPlayer from '@/views/AiiTasks/AudioPlayer.vue'
import { getStyleProperty, getSideMenuWidth } from '@/utils/util'
import {
	DAI_ZHONG_SHEN,
	DAI_QUE_REN,
	YI_WAN_CHENG,
	YI_QU_XIAO,
	YI_GUAN_DAN,
} from '@/web-task/config.ts'

@Component({
	components: {
		AudioPlayer,
	},
})
export default class RecordSection extends Vue {
	private tableData: any = []
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'key',
		},
		{
			title: '录音信息',
			dataIndex: 'name',
		},
		{
			title: '操作',
			dataIndex: 'operation',
			scopedSlots: { customRender: 'operation' },
		},
		{
			title: '时长',
			dataIndex: 'duration',
		},
	]
	private playingKey: number = -1
	private show = false

	@Prop({ default: () => [] })
	private recordList!: any

	// 3016 作业录音 3017 调解录音
	@Prop({ default: () => ['3016', '3017'] })
	private recordTypeList!: any

	@Prop({})
	private orderStatus!: string

	@Prop({ default: () => false })
	private isOtherInvestigate!: boolean

	@Prop({
		default: () => [
			DAI_ZHONG_SHEN,
			DAI_QUE_REN,
			YI_WAN_CHENG,
			YI_QU_XIAO,
			YI_GUAN_DAN,
		],
	})
	private defaultStatusList!: string[]

	@Prop({ default: () => [] })
	private customShowStatus!: string[]

	@Watch('recordList', { immediate: true })
	private onRecordListChange() {
		this.getTableData()
	}

	private get recordShow(): boolean {
		// 订单状态为：待终审、待确认、已完成、已取消、已关单才能看见录音信息
		const statusList = this.defaultStatusList.concat(this.customShowStatus)
		return (
			this.tableData &&
			this.tableData.length > 0 &&
			(statusList.includes(this.orderStatus) || this.isOtherInvestigate)
		)
	}

	private play(key: number) {
		let target = this.tableData.find((row: any) => row.key === key)
		this.playingKey = key
		if (target) {
			this.show = true
			this.setPlayerPos()
			// this.$nextTick(() => {
			// window.scroll({
			// 	top: parseInt(
			// 		getStyleProperty(document.querySelector('.ant-layout'), 'height') ||
			// 			0
			// 	),
			// 	left: 0,
			// 	behavior: 'smooth',
			// })
			// })
		}
	}

	private closeAudio() {
		this.show = false
		this.playingKey = -1
	}

	private onDurationLoad(key: number, duration: string) {
		let newData: any = [...this.tableData]
		let target: any = newData.find((row: any) => row.key === key)
		if (target) {
			target.duration = duration
		}
		this.tableData = newData
	}

	private getTableData() {
		if (!(this.recordList && this.recordList.length > 0)) {
			return
		}
		let res: any = [],
			num: number = 0
		let recordMap = this.list2Map(this.recordList)
		this.recordTypeList.forEach((typeCode: string) => {
			let typeList = recordMap[typeCode] || []
			typeList.forEach((record: any, index: number) => {
				res.push(
					Object.assign({}, record, {
						key: ++num,
						name: `${record.picName} ${typeList.length > 1 ? index + 1 : ''}`,
					})
				)
			})
		})
		this.tableData = res
		console.log(this.tableData, 'this.tableData')
		return res
	}

	private list2Map(recordList: any[]) {
		const obj: any = {}
		if (recordList && recordList.length) {
			for (const record of recordList) {
				if (!obj[record.type]) {
					obj[record.type] = []
				}
				obj[record.type].push(record)
			}
		}

		return obj
	}

	private setPlayerPos() {
		// 设置播放组件在右侧页面区域（对应左侧菜单栏）水平居中
		this.$nextTick(() => {
			let playerEl: any = this.$refs.audioWrapper
			if (playerEl) {
				let width = parseInt(getSideMenuWidth() || 0)
				let rightContentWidth = parseInt(
					getStyleProperty(
						document.querySelector('.ant-layout-content'),
						'width'
					) || 0
				)
				// playerEl.style.left = `${width + rightContentWidth / 2}px`
			}
		})
	}

	private activated() {
		this.setPlayerPos()
		window.addEventListener('resize', this.setPlayerPos)
	}

	private created() {
		this.setPlayerPos()
		window.addEventListener('resize', this.setPlayerPos)
	}

	private deactivated() {
		window.removeEventListener('resize', this.setPlayerPos)
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.setPlayerPos)
	}
}
